import MicroModal from "micromodal";
import React, { useEffect, useRef } from "react";

import { ReactComponent as IconClose } from "../../../../build/images/attendanceIcons/close-side-info.svg";

import "./historic-alert-modal.styles.css";

const HistoricAlertModal = ({ onConfirm = () => {}, onCancel = () => {} }) => {
  const modalRef = useRef(null);

  useEffect(() => {
    // Função para interceptar e parar o evento do Esc
    const handleKeyDown = (event) => {
      if (event.key === "Escape" || event.keyCode === 27) {
        event.stopPropagation();
      }
    };

    const modalElement = modalRef.current;
    if (modalElement) {
      // Adicionamos o listener direto no elemento DOM do modal.
      // Isso impede que o evento suba (bubble up) até o 'document' onde o Micromodal está escutando.
      modalElement.addEventListener("keydown", handleKeyDown);
    }

    // Cleanup na desmontagem do componente
    return () => {
      if (modalElement) {
        modalElement.removeEventListener("keydown", handleKeyDown);
      }
    };
  }, []);
  function closeModal() {
    MicroModal.close("modal__historic-alert-modal");
  }

  return (
    <div
      className="modal micromodal-slide"
      id="modal__historic-alert-modal"
      aria-hidden="true"
      role="dialog"
      ref={modalRef}
    >
      <div className="modal__overlay" tabIndex="-1">
        <div
          className="modal__container"
          role="dialog"
          aria-modal="true"
          aria-labelledby="modal__linkAdd-contact__title"
        >
          <div className="quarantine-modal-content">
            <header className="quarantine-modal-content__header">
              <h1>Associar empresa ao contato</h1>
              <button onClick={onCancel}>
                <IconClose />
              </button>
            </header>
            <p className="quarantine-modal-content__text">
              Você deseja associar este contato a uma empresa?
            </p>
            <footer className="quarantine-modal-content__footer">
              <button
                className="quarantine-modal-content__footer__btn-cancel"
                onClick={() => {
                  onCancel();
                  //   closeModal();
                }}
              >
                Não
              </button>
              <button
                className="quarantine-modal-content__footer__btn-move"
                onClick={() => {
                  onConfirm();
                  //   closeModal();
                }}
              >
                Sim
              </button>
            </footer>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HistoricAlertModal;
